<clr-accordion>
  <clr-accordion-panel>
    <clr-accordion-title>New battery exchange</clr-accordion-title>
    <clr-accordion-content *clrIfExpanded>
      <form clrForm (ngSubmit)="addBatteryExchange()">
        <clr-select-container>
          <label>Address:</label>
          <select clrSelect name="address" [(ngModel)]="addBatteryExchangeData.buildingAddress" (change)="addressChanged()">
            <option *ngFor="let item of buildingAddresses" [ngValue]="item">{{item.description}}</option>
          </select>
        </clr-select-container>
        <clr-select-container>
          <label>Apartment:</label>
          <select clrSelect name="apartment" [(ngModel)]="addBatteryExchangeData.apartment" (change)="apartmentChanged()">
            <option [ngValue]="undefined"></option>
            <option *ngFor="let apartment of apartmentsFiltered" [ngValue]="apartment">{{apartment.externalId}}</option>
          </select>
        </clr-select-container>
        <clr-select-container>
          <label>Facility:</label>
          <select clrSelect name="facility" [(ngModel)]="addBatteryExchangeData.facility" (change)="facilityChanged()">
            <option [ngValue]="undefined"></option>
            <option *ngFor="let facility of facilitiesFiltered" [ngValue]="facility">{{facility.externalId}}</option>
          </select>
        </clr-select-container>
        <clr-select-container>
          <label>Meter:</label>
          <select clrSelect name="meter" [(ngModel)]="addBatteryExchangeData.meter">
            <option [ngValue]="undefined"></option>
            <option *ngFor="let meter of metersFiltered" [ngValue]="meter">{{meter.identifier}}</option>
          </select>
        </clr-select-container>

        <clr-select-container>
          <label>Type:</label>
          <select clrSelect name="meter" [(ngModel)]="addBatteryExchangeData.batteryType">
            <option *ngFor="let batteryType of batteryTypes" [ngValue]="batteryType">{{batteryType}}</option>
          </select>
        </clr-select-container>

        <clr-input-container>
          <label>Message:</label>
          <input clrInput name="message" size="40" [(ngModel)]="addBatteryExchangeData.message" [attr.list]="'messagelist'" />
        </clr-input-container>

        <datalist id="messagelist">
            <option [ngValue]="'ROOM 1'">ROOM 1</option>
            <option [ngValue]="'ROOM 1'">ROOM 2</option>
            <option [ngValue]="'ROOM 1'">ROOM 3</option>
            <option [ngValue]="'ROOM 1'">ROOM 4</option>
        </datalist>

        <clr-input-container>
          <label>Exchage date:</label>
          <input clrInput type="date" step="1" placeholder="" name="exchangedate" [(ngModel)]="addBatteryExchangeData.exchangeDateString" />
        </clr-input-container>

        <br>
        <button type="submit" class="btn btn-outline">
          <clr-icon shape="plus-circle"></clr-icon>
          <ng-container>New battery exchange</ng-container>
        </button>
      </form>
    </clr-accordion-content>
  </clr-accordion-panel>
</clr-accordion>

<clr-datagrid  class="battery-exchanges-table">

  <clr-dg-column [clrDgField]="'address'" [style.min-width.px]="200">
    <ng-container >Address</ng-container>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'apartment'" [style.min-width.px]="100">
    <ng-container >Apartment</ng-container>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'meter'" >
    <ng-container >Meter</ng-container>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'exchangeDate'" [clrDgSortOrder]="descSort">
    <ng-container >Exchange date</ng-container>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'batteryExchange.batteryType'" [style.min-width.px]="250">
    <ng-container >Type</ng-container>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'batteryExchange.message'" [style.min-width.px]="100">
    <ng-container >Message</ng-container>
  </clr-dg-column>
  <clr-dg-column>
    <ng-container ></ng-container>
  </clr-dg-column>

  <clr-dg-row *clrDgItems="let item of batteryExchangeData; let i = index" [clrDgItem]="item">
    <clr-dg-cell [style.min-width.px]="200">{{item.address}}</clr-dg-cell>
    <clr-dg-cell [style.min-width.px]="100">{{item.apartment}}</clr-dg-cell>
    <clr-dg-cell>{{item.meter?.name}}</clr-dg-cell>
    <clr-dg-cell>{{item.exchangeDate | bmsdateformatpipe : 'yyyy-MM-dd'}}</clr-dg-cell>
    <clr-dg-cell [style.min-width.px]="250">{{item.batteryExchange.batteryType}}</clr-dg-cell>
    <clr-dg-cell [style.min-width.px]="100">{{item.batteryExchange.message}}</clr-dg-cell>
    <clr-dg-cell><clr-icon shape="trash" style="cursor: pointer" (click)="deleteBatteryExchange(item.batteryExchange)"></clr-icon></clr-dg-cell>
  </clr-dg-row>
  <clr-dg-footer>
    <clr-dg-pagination #pagination [clrDgPageSize]="10">
      <clr-dg-page-size [clrPageSizeOptions]="[10,20,50,100]">
        Battery exchanges</clr-dg-page-size>
      {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}} of {{pagination.totalItems}} battery exchanges
    </clr-dg-pagination>
  </clr-dg-footer>
</clr-datagrid>
